import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { Badge } from "@/components/ui/badge";
import { noteSourcePath } from "helpers/noteSource";

// A note surfaced from a child record carries a source name; a record's own
// note has none. The entity Notes list and Activity Log share this badge so
// both surfaces name the source identically.
const NoteSourceBadge = ({ sourceName, modelType, modelId }) => {
  if (!sourceName) {
    return null;
  }

  const sourcePath = noteSourcePath(modelType, modelId);

  return (
    <Badge
      variant="outline"
      size="sm"
      render={sourcePath ? <Link to={sourcePath} /> : undefined}
    >
      From {sourceName}
    </Badge>
  );
};

NoteSourceBadge.propTypes = {
  sourceName: PropTypes.string,
  modelType: PropTypes.string,
  modelId: PropTypes.number,
};

export default NoteSourceBadge;
